import { setState, getState, subscribeToStateChange } from '~shared/utils/state';

export const SPECTATE_CLIENT_MODE_KEY = 'spectate-client:mode';
export const SPECTATE_CLIENT_MODE_PROXY = 'proxy';
export const SPECTATE_CLIENT_MODE_UI = 'ui';

/**
 * Sets the spectate client mode.
 * @param {String} mode The client mode
 * @returns {void}
 */
function setSpectateClientMode(mode) {
    setState(SPECTATE_CLIENT_MODE_KEY, mode);
}

/**
 * Sets the spectate client mode to "ui"
 * @returns {void}
 */
export function setSpectateClientModeUi() {
    setSpectateClientMode(SPECTATE_CLIENT_MODE_UI);
}

/**
 * Sets the spectate client mode to "proxy"
 * @returns {void}
 */
export function setSpectateClientModeProxy() {
    setSpectateClientMode(SPECTATE_CLIENT_MODE_PROXY);
}

/**
 * Registers a callback when the spectate client mode changes.
 * @param {Function} cb The callback
 * @returns {Function} The unsubscribe function
 */
export function onSpectateClientModeChange(cb) {
    return subscribeToStateChange(SPECTATE_CLIENT_MODE_KEY, cb);
}

/**
 * Checks whether the spectate client is in ui mode
 * @returns {void}
 */
export function isUiMode() {
    return getState(SPECTATE_CLIENT_MODE_KEY) === SPECTATE_CLIENT_MODE_UI;
}

/**
 * Checks whether the spectate client is in proxy mode
 * @returns {void}
 */
export function isProxyMode() {
    return getState(SPECTATE_CLIENT_MODE_KEY) === SPECTATE_CLIENT_MODE_PROXY;
}
